import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Flex, Text, Icon } from 'components/ui';
import {
    colors, space, radii, gradients, fontSizes, fontWeights, lineHeights
} from 'style/config';
import { wrapFunctionalComponent } from 'utils/framework';
import Actions from 'Actions';
import languageLocale from 'utils/LanguageLocale';
import AssuranceZoneEN from 'components/AssuranceZone/locales/AssuranceZone_en_US';
import AssuranceZoneFR from 'components/AssuranceZone/locales/AssuranceZone_fr_CA';

const getText = languageLocale.getLocalisedDataFromResource(AssuranceZoneEN, AssuranceZoneFR);

const styles = {
    button: {
        appearance: 'none',
        border: 0,
        width: '100%',
        textAlign: 'left',
        cursor: 'pointer',
        background: gradients.assuranceZone,
        borderRadius: radii[2],
        padding: `${space[2]}px ${space[4]}px`,
        color: colors.black
    },
    row: {
        alignItems: 'center',
        gap: space[2],
        width: '100%'
    },
    iconWrapper: {
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 20,
        height: 20,
        backgroundColor: colors.white,
        borderRadius: radii[2]
    },
    textGroup: {
        alignItems: 'center',
        gap: '2px'
    },
    text: {
        fontSize: fontSizes.base,
        lineHeight: lineHeights.tight,
        fontWeight: fontWeights.bold
    }
};

const AssuranceZone = ({ marginY, marginTop, marginBottom, dataAt }) => {
    const dispatch = useDispatch();

    const handleClick = useCallback(() => {
        dispatch(Actions.showFreeReturnsModal({ isOpen: true }));
    }, [dispatch]);

    return (
        <button
            type='button'
            onClick={handleClick}
            aria-label={getText('freeReturnsAriaLabel')}
            data-at={dataAt}
            css={[styles.button, { marginTop: marginTop ?? marginY, marginBottom: marginBottom ?? marginY }]}
        >
            <Flex css={styles.row}>
                <Flex css={styles.iconWrapper}>
                    <Icon
                        name='returns30Day'
                        size={20}
                        viewBox='0 0 20 20'
                    />
                </Flex>
                <Flex css={styles.textGroup}>
                    <Text
                        is='span'
                        css={styles.text}
                        children={getText('freeReturnsMessage')}
                    />
                    <Icon
                        name='chevronRight'
                        size={20}
                    />
                </Flex>
            </Flex>
        </button>
    );
};

export default wrapFunctionalComponent(AssuranceZone, 'AssuranceZone');
